import { create } from 'zustand';

interface SCState {
  scStandards: string[];
  setScStandards: (value: string[]) => void;
  /** Map of standard code → description, e.g. { OCS: "Organic Content Standard", GRS: "Global Recycled Standard" } */
  scStandardDescriptions: Record<string, string>;
  setScStandardDescriptions: (value: Record<string, string>) => void;
  editSCInfo: { scId?: string; isParentStatus?: boolean } | null;
  setEditSCInfo: (value: { scId?: string; isParentStatus?: boolean } | null) => void;
}

export const useScStore = create<SCState>((set) => ({
  scStandards: [],
  setScStandards: (value: string[]) => set({ scStandards: value }),
  scStandardDescriptions: {},
  setScStandardDescriptions: (value: Record<string, string>) => set({ scStandardDescriptions: value }),
  editSCInfo: null,
  setEditSCInfo: (value) => set({ editSCInfo: value }),
}));